import { useRef, useEffect } from "react";
import { Wrapper } from "@googlemaps/react-wrapper";
declare global {
    interface Window {
        google: any;
    }
}

function InnerMapComponent({
    center,
    zoom,
}: {
    center: { lat: number; lng: number };
    zoom: number;
}) {
    const ref = useRef(null);

    useEffect(() => {
        const map = new window.google.maps.Map(ref.current, {
            center,
            zoom,
            mapId: "opportunity-location",
        });
        new window.google.maps.marker.AdvancedMarkerElement({
            position: center,
            map: map,
        });
    }, []);

    return <div ref={ref} id="map" className="map-container h-96 w-full" />;
}

export default function MapComponent({
    APIKey,
    lat,
    long,
}: {
    APIKey: string;
    lat: string;
    long: string;
}) {
    return (
        <Wrapper apiKey={APIKey} libraries={["marker"]}>
            <InnerMapComponent
                center={{
                    lat: parseFloat(lat),
                    lng: parseFloat(long),
                }}
                zoom={16}
            />
        </Wrapper>
    );
}
